<script setup lang="ts">
import { useNetworkStatus } from '../composables/useNetworkStatus'

const { isOnline, isConnecting, forceReconnect } = useNetworkStatus()
</script>

<template>
  <!-- Online Status -->
  <div v-if="isOnline" class="flex items-center text-green-600 text-sm">
    <div class="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse"></div>
    <span class="hidden sm:inline">Online</span>
  </div>

  <!-- Connecting Status -->
  <div v-else-if="isConnecting" class="flex items-center text-yellow-600 text-sm">
    <div class="w-2 h-2 bg-yellow-500 rounded-full mr-2 animate-pulse"></div>
    <span class="hidden sm:inline">Reconnecting...</span>
  </div>

  <!-- Offline Status -->
  <div v-else class="flex items-center text-red-600 text-sm">
    <div class="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
    <span class="hidden sm:inline cursor-pointer hover:underline" @click="forceReconnect">
      Offline - Click to retry
    </span>
    <span class="sm:hidden cursor-pointer hover:underline" @click="forceReconnect">
      Offline
    </span>
  </div>
</template> 